import * as React from "react";
import "./style/App.css";
import { Offline, Online } from "react-detect-offline";
import ScrollToTop from "./components/scrollToTop";

import { BrowserRouter, Redirect, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Profile from "./components/screens/profile";
import Footer from "./components/layout/Footer/Footer";
import SearchedProfile from "./components/screens/searchedProfile";
import SearchUser from "./components/screens/searchUser";
import HighFive from "./components/HighFive/highfive";
import MainReg from "./components/Registration/mainreg";
import RegEmail from "./components/Registration/regEmail";
import RegFacebook from "./components/Registration/regFacebook";
import ProgressScr from "./components/Registration/progress";
import RetrievePassScr from "./components/Registration/retrievePass";
import CheckEmailsScr from "./components/Registration/checkEmails";
import LoginScr from "./components/Registration/login";
import OverviewPage from "./components/overview/OverviewPage";
import AppHome from "./components/screens/appHome";
import NoConnection from "./components/screens/noConnection";
import QuitSmoking from "./components/screens/quitSmoking";
import CookieConsentBan from "./components/cookieConsent/cookieConsent";
import SearchHeader from "./components/searchUser/searchHeader";
import LogOutPage from "./components/screens/logOut";
import DeleteUserAcc from "./components/screens/deleteUser";
import EnterPassScr from "./components/screens/enterPass";
import inAppProfile from "./components/screens/inAppProfile";
import ResetPassword from "./components/resetPassword/ResetPassword";
import ResetPasswordSuccess from "./components/resetPassword/ResetPasswordSuccess";
import firebase from "firebase";
import { Game } from "./components/screens/game";
import DownloadUserData from "./components/screens/downloadUserData";
import { LabellingScreen } from "./components/screens/LabelingScreen";

interface State {
  currentUser: firebase.User;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}
class App extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: undefined,
    };
  }
  UNSAFE_componentWillMount = () => {
    firebase.auth().onAuthStateChanged(
      function (user) {
        if (user) {
          this.setState({ currentUser: user });
        } else {
          this.setState({ currentUser: null });
        }
      }.bind(this)
    );
  };

  public render() {
    return (
      <BrowserRouter>
        <ScrollToTop>
          <div className="MAIN">
            <Route
              path="/(login|profile|profile/:number|highfive|register|registerEmail|registerFacebook|registerProgress|login|overview|noConn|retPass|checkEmails|resetPassword|resetPasswordSuccess|downloadUserData)"
              component={Header}
            />
            <Route path="/search" component={SearchHeader} />
            <Online>
              <div
                className={
                  window.location.href.includes("game") ? "" : "MAIN_HEIGHT"
                }
              >
                <Route exact path="/" component={AppHome} />
                <Route exact path="/profile" component={Profile} />
                <Route path="/profile/:number" component={SearchedProfile} />
                <Route path="/inApp/profile/:number" component={inAppProfile} />
                <Route path="/search" component={SearchUser} />
                <Route path="/highfives/:number" component={SearchedProfile} />
                <Route path="/register" component={MainReg} />
                <Route path="/registerEmail" component={RegEmail} />
                <Route path="/registerFacebook" component={RegFacebook} />
                <Route
                  path="/registerProgress"
                  render={(props) =>
                    this.state.currentUser !== null ? (
                      <ProgressScr {...props} />
                    ) : (
                      <Redirect to={"/"} />
                    )
                  }
                />
                <Route path="/labeling" component={LabellingScreen} />
                <Route path="/login" component={LoginScr} />
                <Route path="/game" component={Game} />
                <Route path="/retPass" component={RetrievePassScr} />
                <Route path="/checkEmails" component={CheckEmailsScr} />
                <Route path="/overview" component={OverviewPage} />
                <Route path="/appHome" component={AppHome} />
                <Route path="/quitSmoking" component={QuitSmoking} />
                <Route path="/logOutScr" component={LogOutPage} />
                <Route path="/deleteAccount" component={DeleteUserAcc} />
                <Route path="/enterPass" component={EnterPassScr} />
                <Route path="/resetPassword/" component={ResetPassword} />
                <Route
                  path="/resetPasswordSuccess"
                  component={ResetPasswordSuccess}
                />
                <Route path="/downloadUserData" component={DownloadUserData} />
              </div>
            </Online>
            <Offline>
              <NoConnection />
            </Offline>
            <CookieConsentBan />
          </div>
          <Footer />
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx